import { Outlet, Link, createRootRoute, HeadContent } from "@tanstack/react-router";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Dra. Rafaela Sales | Cirurgia Cardíaca em Maceió — AL" },
      {
        name: "description",
        content:
          "Dra. Rafaela Sales, cirurgiã cardíaca em Maceió — AL. Atuação em cirurgia cardíaca, doenças valvares, TAVI, aneurismas da aorta, dispositivos cardíacos e cardiopatias congênitas no adulto.",
      },
      { name: "author", content: "Dra. Rafaela Sales" },
      { property: "og:title", content: "Dra. Rafaela Sales | Cirurgia Cardíaca em Maceió — AL" },
      {
        property: "og:description",
        content:
          "Técnica, precisão e cuidado humano em cada etapa do tratamento cardiovascular.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Dra. Rafaela Sales | Cirurgia Cardíaca em Maceió — AL" },
      { name: "description", content: "Your Checkpoint Hub is a web application for managing medical appointments and patient information." },
      { property: "og:description", content: "Your Checkpoint Hub is a web application for managing medical appointments and patient information." },
      { name: "twitter:description", content: "Your Checkpoint Hub is a web application for managing medical appointments and patient information." },
      { property: "og:image", content: "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/8799e36e-5d8e-41c7-91ca-8a9bd3b96904/id-preview-8e2b610d--a4cfb30d-6421-43b3-b72b-a06c6e4ad6d9.lovable.app-1782407968578.png" },
      { name: "twitter:image", content: "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/8799e36e-5d8e-41c7-91ca-8a9bd3b96904/id-preview-8e2b610d--a4cfb30d-6421-43b3-b72b-a06c6e4ad6d9.lovable.app-1782407968578.png" },
    ],
    links: [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Aboreto&family=Work+Sans:wght@300;400;500;600;700&display=swap",
      },
    ],
  }),
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <Outlet />
    </>
  );
}
